import CompraItemRelacionamentoFornecedorService from "@/services/CompraItemRelacionamentoFornecedorService";

export const compraItemRelacionamentoFornecedor = {
  namespaced: true,
  state: {
    compraItemRelacionamentoFornecedor: {},
  },
  actions: {
    deleteCompraItemRelacionamentoFornecedor({ commit }, payload) {
      return CompraItemRelacionamentoFornecedorService.DeleteCompraItemRelacionamentoFornecedor(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCompraItemRelacionamentoFornecedorOData({ commit }, payload) {
      return CompraItemRelacionamentoFornecedorService.GetCompraItemRelacionamentoFornecedorOData(
        payload
      ).then(
        (compraItem) => {
          return Promise.resolve(compraItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default compraItemRelacionamentoFornecedor;
